var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPotentialBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1110,
    viewBox: "0 0 1440 1110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_140_71503",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -835,
    y: 121,
    width: 2289,
    height: 817
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1453.17 121.661H-834.66V937.342H1453.17V121.661Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_140_71503)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-848.143 1102.49C528.856 857.308 1090.5 142.249 1606.51 857.667",
    stroke: "url(#paint0_linear_140_71503)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-850.857 1077.93C520.071 830.309 1075.56 170.357 1605.2 846.769",
    stroke: "url(#paint1_linear_140_71503)",
    strokeWidth: 2.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-853.33 1053.35C511.313 803.212 1060.61 198.547 1603.8 835.823",
    stroke: "url(#paint2_linear_140_71503)",
    strokeWidth: 2.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-856.014 1028.8C502.529 776.147 1045.66 226.672 1602.46 824.925",
    stroke: "url(#paint3_linear_140_71503)",
    strokeWidth: 2.71,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-858.668 1004.26C493.743 749.067 1030.68 254.813 1601.08 814.06",
    stroke: "url(#paint4_linear_140_71503)",
    strokeWidth: 2.61,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-861.107 979.66C484.959 721.905 1015.7 282.97 1599.62 803.114",
    stroke: "url(#paint5_linear_140_71503)",
    strokeWidth: 2.51,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-863.701 955.108C476.173 694.759 1000.76 311.095 1598.22 792.265",
    stroke: "url(#paint6_linear_140_71503)",
    strokeWidth: 2.41,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-866.477 930.589C467.388 667.613 985.78 339.155 1596.84 781.466",
    stroke: "url(#paint7_linear_140_71503)",
    strokeWidth: 2.31,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-869.008 906.036C458.634 640.418 970.833 367.263 1595.41 770.649",
    stroke: "url(#paint8_linear_140_71503)",
    strokeWidth: 2.21,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-871.539 881.468C449.849 613.191 955.825 395.355 1593.92 759.834",
    stroke: "url(#paint9_linear_140_71503)",
    strokeWidth: 2.12,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-874.193 856.933C441.094 585.947 940.878 423.398 1592.51 749.1",
    stroke: "url(#paint10_linear_140_71503)",
    strokeWidth: 2.02,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-876.818 832.397C432.338 558.671 925.929 451.441 1591.11 738.382",
    stroke: "url(#paint11_linear_140_71503)",
    strokeWidth: 1.92,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-879.381 807.861C423.644 531.378 910.982 479.484 1589.73 727.696",
    stroke: "url(#paint12_linear_140_71503)",
    strokeWidth: 1.82,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-881.941 783.309C414.952 504.052 896.067 507.511 1588.36 717.01",
    stroke: "url(#paint13_linear_140_71503)",
    strokeWidth: 1.72,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-884.566 758.774C406.318 476.662 881.179 535.538 1587.14 706.374",
    stroke: "url(#paint14_linear_140_71503)",
    strokeWidth: 1.62,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-887.158 734.254C397.747 449.271 866.325 563.613 1585.98 695.754",
    stroke: "url(#paint15_linear_140_71503)",
    strokeWidth: 1.53,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-889.844 709.734C389.205 421.799 851.499 591.689 1584.92 685.134",
    stroke: "url(#paint16_linear_140_71503)",
    strokeWidth: 1.43,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-892.312 685.183C380.757 394.327 836.737 619.814 1583.91 674.497",
    stroke: "url(#paint17_linear_140_71503)",
    strokeWidth: 1.33,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-894.998 660.68C372.337 366.79 821.971 648.02 1583.06 663.828",
    stroke: "url(#paint18_linear_140_71503)",
    strokeWidth: 1.23,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-897.529 636.144C363.918 339.252 807.208 676.259 1582.17 653.126",
    stroke: "url(#paint19_linear_140_71503)",
    strokeWidth: 1.13,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-900.094 611.625C355.558 311.666 792.472 704.58 1581.44 642.392",
    stroke: "url(#paint20_linear_140_71503)",
    strokeWidth: 1.04,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-902.686 587.122C347.231 284.047 777.74 732.998 1580.77 631.593",
    stroke: "url(#paint21_linear_140_71503)",
    strokeWidth: 0.94,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-905.309 562.619C338.904 256.363 763.006 761.449 1580.16 620.728",
    stroke: "url(#paint22_linear_140_71503)",
    strokeWidth: 0.84,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-907.902 538.099C330.545 228.662 748.241 789.965 1579.49 609.814",
    stroke: "url(#paint23_linear_140_71503)",
    strokeWidth: 0.74,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-910.402 513.58C322.218 200.978 733.509 818.514 1578.82 598.867",
    stroke: "url(#paint24_linear_140_71503)",
    strokeWidth: 0.64,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-913.025 489.093C313.861 173.229 718.715 847.161 1578.18 587.872",
    stroke: "url(#paint25_linear_140_71503)",
    strokeWidth: 0.54,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-915.619 464.59C305.471 145.446 703.919 875.807 1577.53 576.811",
    stroke: "url(#paint26_linear_140_71503)",
    strokeWidth: 0.45,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-918.152 440.087C297.112 117.665 689.093 904.487 1576.83 565.735",
    stroke: "url(#paint27_linear_140_71503)",
    strokeWidth: 0.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-920.744 415.6C288.693 89.8496 674.238 933.231 1576.13 554.641",
    stroke: "url(#paint28_linear_140_71503)",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.21875 985.321C-1.21875 985.321 901.711 526.093 1484.44 779.704",
    stroke: "#C0E7FF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.0292969 990.623C-0.0292969 990.623 895.823 536.256 1484.44 791.727",
    stroke: "#C0E7FF",
    strokeWidth: 0.38,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16016 995.925C1.16016 995.925 889.936 546.419 1484.41 803.734",
    stroke: "#C0E7FF",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34961 1001.23C2.34961 1001.23 884.048 556.582 1484.4 815.741",
    stroke: "#C0E7FF",
    strokeWidth: 0.62,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57031 1006.53C3.57031 1006.53 878.161 566.746 1484.44 827.747",
    stroke: "#C0E7FF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75977 1011.83C4.75977 1011.83 872.274 576.909 1484.41 839.754",
    stroke: "#C0E7FF",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94922 1017.13C5.94922 1017.13 866.386 587.073 1484.41 851.761",
    stroke: "#C0E7FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16992 1022.43C7.16992 1022.43 860.53 597.236 1484.44 863.768",
    stroke: "#C0E7FF",
    strokeWidth: 1.12,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35938 1027.74C8.35938 1027.74 854.642 607.4 1484.44 875.775",
    stroke: "#C0E7FF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54883 1033.04C9.54883 1033.04 848.755 617.563 1484.41 887.782",
    stroke: "#C0E7FF",
    strokeWidth: 1.38,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7383 1038.34C10.7383 1038.34 842.867 627.726 1484.4 899.788",
    stroke: "#C0E7FF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.959 1043.64C11.959 1043.64 836.98 637.906 1484.44 911.812",
    stroke: "#C0E7FF",
    strokeWidth: 1.62,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1484 1048.94C13.1484 1048.94 831.093 648.07 1484.44 923.819",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3379 1054.25C14.3379 1054.25 825.205 658.233 1484.4 935.825",
    stroke: "#C0E7FF",
    strokeWidth: 1.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5586 1059.55C15.5586 1059.55 819.349 668.396 1484.44 947.832",
    stroke: "#C0E7FF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M641.995 76.3418C641.995 76.3418 -281.251 523.873 -852.445 262.872",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M641.049 71.04C641.049 71.04 -274.906 513.792 -851.896 250.865",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M640.072 65.7217C640.072 65.7217 -268.562 503.71 -851.348 238.858",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M639.128 60.4033C639.128 60.4033 -262.216 493.628 -850.828 226.851",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M638.151 55.0854C638.151 55.0854 -255.902 483.53 -850.279 214.845",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M637.205 49.7671C637.205 49.7671 -249.557 473.448 -849.73 202.838",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M636.23 44.4487C636.23 44.4487 -243.211 463.366 -849.211 190.847",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M635.284 39.1309C635.284 39.1309 -236.866 453.285 -848.662 178.841",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M634.307 33.8286C634.307 33.8286 -230.553 443.186 -848.145 166.834",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M633.361 28.5103C633.361 28.5103 -224.208 433.104 -847.596 154.827",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M632.385 23.1924C632.385 23.1924 -217.864 423.023 -847.047 142.82",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M631.44 17.874C631.44 17.874 -211.518 412.941 -846.527 130.813",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M630.464 12.5557C630.464 12.5557 -205.204 402.843 -845.979 118.806",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M629.518 7.2373C629.518 7.2373 -198.859 392.761 -845.43 106.799",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M628.543 1.93555C628.543 1.93555 -192.513 382.679 -844.91 94.7927",
    stroke: "#C0E7FF",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_140_71503",
    x1: -878.83,
    y1: 825.252,
    x2: 1616,
    y2: 825.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0FA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#E618AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#A630C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4156E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_140_71503",
    x1: -880.721,
    y1: 814.289,
    x2: 1614.78,
    y2: 814.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F817A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#DF1FAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A035C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3C58E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076BFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_140_71503",
    x1: -882.614,
    y1: 803.277,
    x2: 1613.53,
    y2: 803.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F01FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D726B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#993AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#3659E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D67F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_140_71503",
    x1: -884.535,
    y1: 792.249,
    x2: 1612.28,
    y2: 792.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E926AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#D12CB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#933EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#315AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1463F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_140_71503",
    x1: -886.427,
    y1: 781.172,
    x2: 1611.06,
    y2: 781.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C933B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#8C43CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2A5BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B5FF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_140_71503",
    x1: -888.317,
    y1: 770.013,
    x2: 1609.81,
    y2: 770.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA36B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C23ABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8546CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#255AEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215BEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_140_71503",
    x1: -890.209,
    y1: 758.789,
    x2: 1608.59,
    y2: 758.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D33EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BB41BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#7F4AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2857EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_140_71503",
    x1: -892.131,
    y1: 747.501,
    x2: 1607.34,
    y2: 747.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB46BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B347C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#784CD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F53E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_140_71503",
    x1: -894.021,
    y1: 736.048,
    x2: 1606.09,
    y2: 736.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C44EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#AD4EC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#724ED3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354FE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_140_71503",
    x1: -895.912,
    y1: 724.433,
    x2: 1604.87,
    y2: 724.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC55C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A553C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6B4ED5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C4BE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_140_71503",
    x1: -897.804,
    y1: 712.606,
    x2: 1603.62,
    y2: 712.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B55DC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9E58C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#654DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4247DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_140_71503",
    x1: -899.727,
    y1: 700.469,
    x2: 1602.39,
    y2: 700.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE65C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#975DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5F4AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4943DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_140_71503",
    x1: -901.619,
    y1: 687.891,
    x2: 1601.14,
    y2: 687.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A66DCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9061CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#5743D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#503FD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_140_71503",
    x1: -903.508,
    y1: 674.709,
    x2: 1599.89,
    y2: 674.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F75CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8963CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563BD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_140_71503",
    x1: -905.401,
    y1: 660.745,
    x2: 1598.67,
    y2: 660.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#977DD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8567D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D37D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_140_71503",
    x1: -907.322,
    y1: 645.785,
    x2: 1597.42,
    y2: 645.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9084D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#846ED2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#6637CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6434CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_140_71503",
    x1: -909.214,
    y1: 629.684,
    x2: 1596.17,
    y2: 629.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898CD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#8176D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6F40CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A30C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_140_71503",
    x1: -911.103,
    y1: 612.391,
    x2: 1594.95,
    y2: 612.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8194DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7D7FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7549CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#712CC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_140_71503",
    x1: -912.996,
    y1: 595.588,
    x2: 1593.7,
    y2: 595.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A9CDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#7987D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7851CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7828C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_140_71503",
    x1: -914.917,
    y1: 583.728,
    x2: 1592.45,
    y2: 583.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73A4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#748FDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#795ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E24BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_140_71503",
    x1: -916.81,
    y1: 573.304,
    x2: 1591.23,
    y2: 573.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BABE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6E96DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#7861CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8520BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_140_71503",
    x1: -918.7,
    y1: 563.581,
    x2: 1589.98,
    y2: 563.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#699EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#776AD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C1CB9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_140_71503",
    x1: -920.591,
    y1: 554.119,
    x2: 1588.76,
    y2: 554.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CBBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#62A6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7372D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#8F1FB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9218B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_140_71503",
    x1: -922.514,
    y1: 544.722,
    x2: 1587.51,
    y2: 544.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55C3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5CAFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#707BD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9029B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9914B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_140_71503",
    x1: -924.404,
    y1: 535.293,
    x2: 1586.26,
    y2: 535.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ECBF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#56B7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#6C84D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#9032BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F10AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_140_71503",
    x1: -926.295,
    y1: 525.799,
    x2: 1585.04,
    y2: 525.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46D3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4FBFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#678CDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8F3BBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60CAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_140_71503",
    x1: -928.187,
    y1: 516.206,
    x2: 1583.79,
    y2: 516.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FDAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#49C6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#6394DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#8D43BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD08A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_140_71503",
    x1: -930.11,
    y1: 506.532,
    x2: 1582.54,
    y2: 506.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37E2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#41CEF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5D9CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#8A4CC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B304A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_140_71503",
    x1: -932,
    y1: 496.777,
    x2: 1581.32,
    y2: 496.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3BD6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#58A5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#8755C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA00A1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotentialBg);
export default __webpack_public_path__ + "static/media/potentialBG.8c00f1ea3c62b415483c24ea8341be24.svg";
export { ForwardRef as ReactComponent };